export const apiKey = 'AIzaSyCnsUhAzLLofMvSGgLa2m9zR1VdGwUZVms';
